import { isRecord } from "utils/isRecord";

export const DECREMENT_PRO_CREDIT_USAGE_TOOL_NAME = "decrement_pro_credit_usage";

export type ScoutProCreditUsage = {
  proCreditsRemaining: number;
};

/** The banner shows only for a credit this turn actually spent. */
export function parseScoutProCreditUsage(output: unknown): ScoutProCreditUsage | null {
  if (!isRecord(output)) return null;
  if (output.kind !== "scout_pro_credit_usage" || output.status !== "spent") return null;
  const proCreditsRemaining = output.proCreditsRemaining;
  if (typeof proCreditsRemaining !== "number") return null;
  return { proCreditsRemaining };
}

export type ScoutProCreditBannerCopy = {
  title: string;
  body: string;
  remaining: string;
};

export function scoutProCreditBannerCopy(proCreditsRemaining: number): ScoutProCreditBannerCopy {
  if (proCreditsRemaining <= 0) {
    return {
      title: "That was your last Scout Pro preview",
      body: "Scout Pro understands your Encamp data. Upgrade to keep answers like this coming.",
      remaining: "Your next questions will use Regulatory Advisor",
    };
  }
  const previews = proCreditsRemaining === 1 ? "preview" : "previews";
  return {
    title: "This answer was powered by Scout Pro",
    body: "You have access to Scout Regulatory Advisor, but you're getting a taste of Scout Pro: Scout went beyond the regulations and understands your Encamp data.",
    remaining: `${proCreditsRemaining} Pro ${previews} left`,
  };
}
